import request from "./axios.service";
import { GET, POST, BASE_URL, ADMIN, AUTH, COMPANY, CLIENT, COMMON, OTHERS } from "../app.config";

//////////////////////////////////////////////////////////////////////
//                               Auth                               //
//////////////////////////////////////////////////////////////////////

export const loginApi = (body) => {
  // console.log("body-----------", body);
  
   return request(`${BASE_URL}/${ADMIN}/${AUTH}/${ADMIN}/login`, POST, false, body)
    .then((response) => {
      // console.log(response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const logoutApi = (body) => {
  // console.log("body-----------*************************", body);
  return request(`${BASE_URL}/${ADMIN}/${AUTH}/${ADMIN}/logout`, POST, true, body)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const forgotPasswordApi = (data) => {
  //console.log("dataooooooooo",data);
  
  return request(`${BASE_URL}/${ADMIN}/${AUTH}/admin/forgotpassword`, POST, false, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const resetPasswordAPI = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${AUTH}/${ADMIN}/change_password`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const changePasswordAPI = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${AUTH}/${ADMIN}/change_password`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editProfileDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${AUTH}/${ADMIN}/edit_profile`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const forgotPasswordChange = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${AUTH}/${ADMIN}/forgotPasswordEmail`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};



//////////////////////////////////////////////////////////////////////
//                              Common                              //
//////////////////////////////////////////////////////////////////////

export const getAppContentApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMMON}/app_content`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCredentialApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMMON}/get_credential`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editAppContentApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMMON}/edit_app_content`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCountryListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMMON}/country_list`, GET, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                              Other                             //
//////////////////////////////////////////////////////////////////////

export const getDashboardCountApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/dashboard`, GET, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                              Subadmin                            //
//////////////////////////////////////////////////////////////////////

export const getSubadminApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subadmin/subadminList`,POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};

export const updateSubadminApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subadmin/updateSubadmin`,POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};

export const getAllModuleApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subadmin/getmoduleSubadmin`,POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};


export const getpermissionApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subadmin/getpermission`,POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};

export const addSubadminApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subadmin/addSubadmin`,POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};

export const updatePermissionApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subadmin/updatepermission`,POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
     // console.log("hello hear a error");
      
      throw error;
    });
};





//////////////////////////////////////////////////////////////////////
//                              OTHERS                              //
//////////////////////////////////////////////////////////////////////

export const getFaqListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/faq_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editFaqApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/edit_faq`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addFaqApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/add_faq`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getFaqExportListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/faq_export_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getContactListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/contectus_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const contectUsReplay = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/contectus_replay`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

// export const editContactApi = (data) => {
//   return request(`${BASE_URL}/${ADMIN}/${OTHERS}/edit_contact`, POST, true, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       throw error;
//     });
// };

export const getContactListExportApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/contact_list_export`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllUserListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/all_user_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addNotificationApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/add_notification`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteNotificationApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/delete_notification`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getNotificationListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/notification_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const getLeaderboardApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/leaderboard`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const tournamentLeaderboardApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/tournamenet_leaderboard`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const getSettingsAPI = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/get_smtp`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateSettingsAPI = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${OTHERS}/update_smtp`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};



//////////////////////////////////////////////////////////////////////
//                             Company                              //
//////////////////////////////////////////////////////////////////////

export const getCompanyListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/company_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCompanyDeviceDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/company_device_details`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCompanyListExportApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/company_list_export`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editCompanyDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/edit_company`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/organization_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editOrganizationDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/edit_organization_details`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTeamListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/team_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editTeamDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/edit_team_details`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getEmployeeListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/employee_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editEmployeeDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/edit_employee`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTaskListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${COMPANY}/task_list`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};



//////////////////////////////////////////////////////////////////////
//                              User                            //
//////////////////////////////////////////////////////////////////////

export const getUserListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/customer/customer/customerlist`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUserBeasdOnTeacherApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/customer/customer/CustomerlistTeacher`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteUserApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/customer/customer/deleteCustomer`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUserDetailApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/customer/customer/customerDetails`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const getClientDeviceDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/${CLIENT}/client_device_details`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const editClientDetailsApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/customer/customer/updateCustomerlist`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};




export const getClientExportListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/customer/customer/customerlistExport`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//////////////////////////////////////////////////////////////////////
//                              Latter                               //
//////////////////////////////////////////////////////////////////////

export const getLatterListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/latter/latter/latterlist`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateLatterApi = (data) => {

  //console.log("7777777777777777777777777777777777777777777777777777",data);
  
  return request(`${BASE_URL}/${ADMIN}/latter/latter/updatelatterlist`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertLatterApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/latter/latter/addlatter`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                    Ladder   Letter                               //
//////////////////////////////////////////////////////////////////////

export const getLadderLetterListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/LadderLetter/ladderLetter/ladderletterlist`, POST, true, data)
    .then((response) => {
      console.log("*********************************************",response); 
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateLadderLetterApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/LadderLetter/ladderLetter/updateladderletterlist`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertLadderLetterApi = (data) => {
  //console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/LadderLetter/ladderLetter/addladderletter`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//////////////////////////////////////////////////////////////////////
//                    Number                                       //
//////////////////////////////////////////////////////////////////////

export const getNumberListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/number/number/numberlist`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateNumberApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/number/number/updateNumberlist`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertNumberApi = (data) => {
  //console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/number/number/addNumber`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                    Word                                         //
//////////////////////////////////////////////////////////////////////

export const getWordListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/word/word/wordList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateWordApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/word/word/updateWordList`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertWordApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/word/word/addWord`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                    Sentence                                       //
//////////////////////////////////////////////////////////////////////

export const getSentenceListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/sentence/sentence/sentenceList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateSentenceApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/sentence/sentence/updateSentenceList`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertSentenceApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/sentence/sentence/addSentence`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                    category                                      //
//////////////////////////////////////////////////////////////////////

export const getCategaryListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/category/category/categoryList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateCategoryApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/category/category/updateCategory`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertCategoryApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/category/category/addCategory`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};



//////////////////////////////////////////////////////////////////////
//                    Tournament                                   //
//////////////////////////////////////////////////////////////////////

export const getTournamentApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/tournament/tournament/tournamentList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateTournamentApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/tournament/tournament/updateTournament`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTournamentrangeApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/tournament/tournament/getTournamentRange`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertTournamentApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/tournament/tournament/addTournament`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteTournamentApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/tournament/tournament/delete_turnament`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                    Challenge                                   //
//////////////////////////////////////////////////////////////////////

export const getChallengeApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/dailyChallenges/dailyChallenges/dailyChallengesList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateChallengeApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/dailyChallenges/dailyChallenges/updateDailyChallenges`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertChallengeApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/dailyChallenges/dailyChallenges/addDailyChallenges`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//////////////////////////////////////////////////////////////////////
//                    Badge                                         //
//////////////////////////////////////////////////////////////////////

export const getBadgeApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/badge/badge/badgeList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateBadgeApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/badge/badge/updateBadge`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertBadgeApi = (data) => {
  // console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/badge/badge/addBadge`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};



//////////////////////////////////////////////////////////////////////
//                   Teacher                                       //
//////////////////////////////////////////////////////////////////////

export const getTeacherListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/teacher/teacher/teacherList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSchoolTeacherListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/teacher/teacher/schoolTeacherList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateTeacherApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/teacher/teacher/updateTeacher`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                   School                                      //
//////////////////////////////////////////////////////////////////////

export const getSchoolListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/school/school/schoolList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateSchoolApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/school/School/updateSchool`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

// Manual (invoice) subscription: grant a school N seats for a validity window.
export const grantSchoolSubscriptionApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/school/school/grantSubscription`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


//////////////////////////////////////////////////////////////////////
//                    Blog                                         //
//////////////////////////////////////////////////////////////////////

export const getBlogApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/blog/blog/blogList`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateBlogApi = (data) => {

  return request(`${BASE_URL}/${ADMIN}/blog/blog/updateBlog`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertBlogApi = (data) => {
  //console.log("7777777777777777777777777777777777777777777777777777",data);
  return request(`${BASE_URL}/${ADMIN}/blog/blog/addBlog`, POST, true, data)
  
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

//////////////////////////////////////////////////////////////////////
//                             Subscription                              //
//////////////////////////////////////////////////////////////////////

export const getSubscriptionListApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subscription/subscription-details`, POST, true, data)
    .then((response) => {
      // console.log("*********************************************",response);
      
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const updateSubscriptionApi = (data) => {

  //console.log("7777777777777777777777777777777777777777777777777777",data);
  
  return request(`${BASE_URL}/${ADMIN}/subscription/edit-subscription`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateSubscriptionStatusApi = (data) => {

  //console.log("7777777777777777777777777777777777777777777777777777",data);
  
  return request(`${BASE_URL}/${ADMIN}/subscription/edit-subscription-status`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const insertSubscriptionApi = (data) => {
  return request(`${BASE_URL}/${ADMIN}/subscription/add-subscription`, POST, true, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};